import React, { useEffect, useState } from "react";
import { Formik, FormikProvider, useFormik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import CommonFormHeading from "../CommonUtils/CommonFormHeading";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { failureAlert, successAlert2, successAlertRefresh } from "../CommonUtils/SweetAlerts";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { viewImage } from "../CommonUtils/viewImage";
import { convertToInputDate } from "../CommonUtils/CommonValidations";
import moment from "moment/moment";
import axios from "axios";
// ---- Validation schema ----
const validationSchema = Yup.object().shape({
  tenderNotificationsEntryList: Yup.array().of(
    Yup.object().shape({
      tenderDate: Yup.date().required("Date is required"),
      tenderDescription: Yup.string().required("Description is required"),
      tenderFile1: Yup.mixed().required("PDF is required"),
    }),
  ),
});

export default function TenderNotifications() {
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const formik = useFormik({
    initialValues: {
      tenderNotificationsEntryList: [
        {
          tenderDate: "",
          tenderDescription: "",
          tenderFile1: "",
        },
      ],
    },

    validationSchema,

    onSubmit: (values, { resetForm }) => {
      Swal.fire({
        text: "Are you sure you want to submit?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = isEdit ? `${config.url.STU_URL}updateTenderNotificationsData/${editId}` : `${config.url.STU_URL}saveTenderNotificationsData`;
          let payload;
          if (isEdit) {
            payload = {
              tenderNotificationsList: values.tenderNotificationsEntryList.map((item) => ({
                tenderId: editId,
                tenderNotificationDate: item.tenderDate,
                tenderDetails: item.tenderDescription,
                tenderFile: item.tenderFile1,
              })),
            };
          } else {
            payload = {
              tenderNotificationsList: values.tenderNotificationsEntryList.map((item) => ({
                tenderNotificationDate: item.tenderDate,
                tenderDetails: item.tenderDescription,
                tenderFile: item.tenderFile1,
              })),
            };
          }
          CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
              successAlertRefresh(res?.data?.sdesc);
              GetTenderNotificationsData();
              // resetForm();
              setShowModal(false);
              setIsEdit(false);
              setEditId(null);
            } else {
              failureAlert(res?.data?.sdesc);
            }
          });
        } else {
          console.log("Submission canceled");
        }
      });
    },
  });

  const [tenderNotifications, setTenderNotifications] = useState([]);
  function GetTenderNotificationsData() {
    let url = config.url.STU_URL + `ov-public/getTenderNotificationsData`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setTenderNotifications(res?.data?.data);
      } else {
        setTenderNotifications([]);
      }
    });
  }

  useEffect(() => {
    GetTenderNotificationsData();
  }, []);
  //  const [tenderNotifications, setTenderNotifications] = useState([]);

  // async function GetTenderNotificationsData() {
  //   try {
  //     const response = await axios.get(config.url.STU_URL + "ov-public/getTenderNotificationsData");
  //     if (response?.data?.scode === "01") {
  //       setTenderNotifications(response?.data?.data || []);
  //     } else {
  //       setTenderNotifications([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching tender notifications:", error);
  //   }
  // }


  const handleOpenModal = () => {
    setIsEdit(false);
    setEditId(null);
    formik.resetForm();
    setShowModal(true);
  };

  const handleCloseModal = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
    setShowModal(false);
  };

  const handleEdit = (item) => {
    setIsEdit(true);
    setEditId(item.tender_id);

    formik.setValues({
      tenderNotificationsEntryList: [
        {
          tenderDate: item.tender_notification_date || "",
          tenderDescription: item.tender_details || "",
          tenderFile1: item.tender_file || "",
        },
      ],
    });

    setShowModal(true);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Delete Tender Notifications",
      text: "Are you sure you want to delete this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        let url = config.url.STU_URL + `deleteTenderNotificationsData/${id}`;
        CommonAxiosPost(url).then((res) => {
          if (res?.data?.scode === "01") {
            successAlert2(res?.data?.sdesc);
            GetTenderNotificationsData();
          } else {
            failureAlert(res?.data?.sdesc);
          }
        });
      }
    });
  };

  return (
    <div className="affl-newdiv">
      <CommonFormHeading heading="Tender Notifications" />

      <div className="col-12">
        <Row>
          <Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10} />
          <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
            <div className="d-flex flex-row justify-content-end">
              <Button type="button" size="sm" variant="primary" onClick={handleOpenModal}>
                + Add Tender Notifications
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      <br />
      {tenderNotifications?.length > 0 && (
        <>
          <div className="table-responsive">
            <table className="table table-bordered table-sm affl-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date of Notification</th>
                  <th className="text-start">Tender Details</th>
                  <th>PDF</th>
                  <th className="text-center">Edit / Delete</th>
                </tr>
              </thead>

              <tbody>
                {tenderNotifications.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>{moment(item.tender_notification_date).format("DD-MM-YYYY")}</td>
                    <td>{item.tender_details || "-"}</td>
                    <td className="text-center">
                      {item.tender_file ? (
                        <button type="button" className="btn btn-sm btn-success" onClick={() => viewImage(item.tender_file)}>
                          <FaEye />
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-center">
                      <button className="btn btn-sm btn-primary me-2">
                        <FaEdit onClick={() => handleEdit(item)} />
                      </button>
                      <button className="btn btn-danger btn-sm">
                        <FaTrash onClick={() => handleDelete(item.tender_id)} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}


      {/* ---- Add Tender Notifications Modal ---- */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered className="inner-modalnew">
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit Tender Notifications" : "Add Tender Notifications"}</Modal.Title>
        </Modal.Header>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit} onChange={formik.handleChange}>
            <Modal.Body>
              <div className="table-responsive">
                <table className="table table-condensed table-bordered table-sm affl-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Date of Notification</th>
                      <th className="text-left">Tender Details</th>
                      <th>Upload PDF</th>
                      {!isEdit && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    <FieldArray name="tenderNotificationsEntryList">
                      {({ push, remove }) => (
                        <>
                          {formik.values.tenderNotificationsEntryList.map((detail, index) => (
                            <tr key={index}>
                              <td>
                                <center>{index + 1}</center>
                              </td>
                              <td>
                                <Field type="date" className="form-control" name={`tenderNotificationsEntryList[${index}].tenderDate`} />
                                <ErrorMessage name={`tenderNotificationsEntryList[${index}].tenderDate`} component="div" className="text-error" />
                              </td>
                              <td>
                                <Field as="textarea" rows={2} className="form-control" name={`tenderNotificationsEntryList[${index}].tenderDescription`} placeholder="Enter description" />
                                <ErrorMessage name={`tenderNotificationsEntryList[${index}].tenderDescription`} component="div" className="text-error" />
                              </td>

                              <td>
                                {isEdit && detail.tenderFile1 && typeof detail.tenderFile1 === "string" && (
                                  <div className="mb-2">
                                    <span
                                      className="text-primary text-decoration-underline"
                                      style={{ cursor: "pointer" }}
                                      role="button"
                                      tabIndex={0}
                                      onClick={() => viewImage(detail.tenderFile1)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                          e.preventDefault();
                                          viewImage(detail.tenderFile1);
                                        }
                                      }}
                                    >
                                      <FaEye /> View Existing PDF
                                    </span>
                                  </div>
                                )}

                                <input
                                  type="file"
                                  className="form-control mt-3 mb-2"
                                  accept="application/pdf"
                                  name={`tenderNotificationsEntryList[${index}].tenderFile1`}
                                  onChange={(e) => {
                                    const fieldName = `tenderNotificationsEntryList[${index}].tenderFile1`;
                                    const fileName = `${Date.now()}_tender_${index}`;
                                    const path = "/ApKwdc/Uploads/tenderFile1/";
                                    ImagePdfBucket(e, formik, path, fieldName, fileName, "pdf");
                                  }}
                                />
                                <ErrorMessage name={`tenderNotificationsEntryList[${index}].tenderFile1`} component="div" className="text-error" />
                              </td>
                              {!isEdit && (
                                <td align="center">
                                  {index === 0 && (
                                    <button
                                      type="button"
                                      className="button-title btn btn-sm btn-success"
                                      onClick={() =>
                                        push({
                                          tenderDate: "",
                                          tenderDescription: "",
                                          tenderFile1: "",
                                        })
                                      }
                                    >
                                      <VscDiffAdded />
                                    </button>
                                  )}
                                  {index >= 1 && (
                                    <button type="button" className="button-title btn btn-sm btn-danger" onClick={() => remove(index)}>
                                      <BiTrash />
                                    </button>
                                  )}
                                </td>
                              )}
                            </tr>
                          ))}
                        </>
                      )}
                    </FieldArray>
                  </tbody>
                </table>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" size="sm" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button type="submit" variant="success" onClick={() => {}}>
                {isEdit ? "Update" : "Submit"}
              </Button>
            </Modal.Footer>
          </Form>
        </FormikProvider>
      </Modal>
    </div>
  );
}
